import React, { useEffect } from "react";
import { X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Slim top banner shown to DE/AT visitors when EUR was auto-selected.
 * Dismisses on click of the "back to CHF" link or the close button — user's
 * choice is then persisted in localStorage and won't reappear.
 */
const AutoRegionBanner = () => {
  const cart = useCart();
  const { lang } = useLanguage();

  const visible = cart.autoRegionApplied && cart.region === "eu";

  useEffect(() => {
    if (visible) {
      document.documentElement.style.setProperty("--promo-h", "36px");
    } else {
      document.documentElement.style.setProperty("--promo-h", "0px");
    }
    return () => {
      document.documentElement.style.setProperty("--promo-h", "0px");
    };
  }, [visible]);

  if (!visible) return null;

  const t = {
    msg:
      lang === "de"
        ? "Preise werden automatisch in EUR angezeigt (Versand aus Deutschland)."
        : "Prices are shown in EUR automatically (ships from Germany).",
    switch:
      lang === "de" ? "Zurück zu CHF" : "Switch to CHF",
    close: lang === "de" ? "Schließen" : "Close",
  };

  return (
    <div
      data-testid="auto-region-banner"
      className="fixed top-0 left-0 right-0 z-[65] bg-[#00A651]/10 border-b border-[#00A651]/30 text-[#00A651] px-4 flex items-center justify-center gap-3 text-[11px] font-condensed uppercase tracking-widest"
      style={{ height: "36px" }}
    >
      <span>🇩🇪 🇦🇹 {t.msg}</span>
      <button
        type="button"
        onClick={() => {
          cart.setRegion("ch");
        }}
        data-testid="auto-region-switch-chf"
        className="underline underline-offset-4 hover:text-white transition-colors"
      >
        {t.switch}
      </button>
      <button
        type="button"
        onClick={cart.dismissAutoRegion}
        data-testid="auto-region-dismiss"
        aria-label={t.close}
        className="ml-1 text-[#00A651]/70 hover:text-white transition-colors"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default AutoRegionBanner;
